import React from 'react';
import { Badge } from '../ui/Badge';
import { OSStatus } from '../../lib/types';
export const statusConfig: Record<OSStatus, {
  label: string;
  color: string;
}> = {
  aguardando: {
    label: 'Aguardando',
    color: 'bg-slate-500/10 text-slate-500 hover:bg-slate-500/20 border-slate-500/20'
  },
  em_analise: {
    label: 'Em Análise',
    color: 'bg-blue-500/10 text-blue-500 hover:bg-blue-500/20 border-blue-500/20'
  },
  aprovado: {
    label: 'Aprovado',
    color: 'bg-emerald-500/10 text-emerald-500 hover:bg-emerald-500/20 border-emerald-500/20'
  },
  executando: {
    label: 'Executando',
    color: 'bg-automotive-orange/10 text-automotive-orange hover:bg-automotive-orange/20 border-automotive-orange/20'
  },
  finalizado: {
    label: 'Finalizado',
    color: 'bg-purple-500/10 text-purple-500 hover:bg-purple-500/20 border-purple-500/20'
  },
  entregue: {
    label: 'Entregue',
    color: 'bg-zinc-500/10 text-zinc-500 hover:bg-zinc-500/20 border-zinc-500/20'
  }
};
export function StatusBadge({
  status,
  className
}: {
  status: OSStatus;
  className?: string;
}) {
  const config = statusConfig[status];
  return <Badge variant="outline" className={`${config.color} ${className}`} data-id="element-243">
      {config.label}
    </Badge>;
}